import React, { useState } from 'react'
import { Text } from '../text/Text'
import { Button, makeStyles, mergeClasses, Popover, PopoverSurface, PopoverTrigger, PositioningShorthand, tokens } from '@fluentui/react-components'
import { Dismiss20Regular } from '@fluentui/react-icons'
type InformationPopoverProps = {
   btnLabel: string
   popoverLabel: string
   regularIcon: JSX.Element
   filledIcon: JSX.Element
   link?: JSX.Element
   input: JSX.Element
   position?: PositioningShorthand
   className?: string
}
const useStyles = makeStyles({
   hideInPhone: {
      '@media screen and (max-width: 640px)': {
         display: 'none',
      },
   },
   brand: {
      color: tokens.colorNeutralForeground2BrandSelected,
   },
   surface: {
      backgroundColor: tokens.colorBrandBackground2,
      width: '800px',
      maxWidth: '100%',
      maxHeight: '70vh',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
   },

   header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'sticky',
      top: 0,
      backgroundColor: 'inherit',
      zIndex: 1,
      paddingBlockEnd: tokens.spacingVerticalS,

      '> *': { marginBottom: 0 },
   },
   content: {
      flex: 1,
      overflowY: 'auto',
      paddingTop: tokens.spacingVerticalL,
      scrollbarWidth: 'thin',
      scrollbarColor: `${tokens.colorBrandStroke2} transparent`,
   },
   spaceBtw: {
      display: 'flex',
      justifyContent: 'space-between',
      '> *': {
         marginBottom: 0,
      },
   },
})
export const InformationPopover = ({ btnLabel, popoverLabel, regularIcon, filledIcon, link, input, position, className }: InformationPopoverProps) => {
   const classes = useStyles()
   const [open, setOpen] = useState<boolean>(false)

   return (
      <Popover open={open} onOpenChange={(e, data) => setOpen(data.open ?? false)} size="large" positioning={position}>
         <PopoverTrigger>
            <Button className={open ? classes.brand : ''} appearance="transparent" icon={open ? filledIcon : regularIcon}>
               <Text size={200} style={{ margin: '0 auto' }} className={classes.hideInPhone}>
                  {btnLabel}
               </Text>
            </Button>
         </PopoverTrigger>

         <PopoverSurface className={mergeClasses(classes.surface, className ?? '')}>
            <header className={classes.header}>
               <Text as="h4" size={500} weight="semibold">
                  {popoverLabel}
               </Text>
               <Button className={open ? classes.brand : ''} onClick={() => setOpen(false)} appearance="transparent" icon={<Dismiss20Regular />} />
            </header>

            <div className={classes.content}>{input}</div>
            {link ?? null}
         </PopoverSurface>
      </Popover>
   )
}
